
export const setLoginTokens = (authData) => {
	if(authData.success){
		localStorage.setItem("jawab_token", authData.access);
		localStorage.setItem("jawab_refreshToken", authData.refresh);
		localStorage.setItem("jawab_user", JSON.stringify(authData.user));
	}
};

export const getLoginTokens = () => {
	const authData = {
		"jawab_token": localStorage.getItem("jawab_token"),
		"jawab_refreshToken": localStorage.getItem("jawab_refreshToken"),
		"jawab_user":  localStorage.getItem("jawab_user"),
	}
	return authData;
};

export const removeLoginTokens = (response) => {
	if(response.success){
		localStorage.removeItem("jawab_token");
		localStorage.removeItem("jawab_refreshToken");
		localStorage.removeItem("jawab_user");
	}
};

export const resetUserData = (response) => {
	localStorage.clear();
	sessionStorage.clear();
	
	document.cookie.split(";").forEach((cookie) => {
		const name = cookie.split("=")[0].trim();
		document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
	});
}